import { config } from '@/config'

/** Get a full registry URL with a resource path */
export function registryUrl(path: string) {
  return `${config.projects.registry}/${path}`
}
